import React, { useEffect, useState } from "react";
import ReactHtmlParser from "react-html-parser";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";
import * as S from "./styles.js";
import { Creators as PromoActions } from "~/store/modules/promo/actions";
import { useDispatch, useSelector } from "react-redux";
import { Margin, Loading } from "~/components/elements";

export default function FAQList({limit = 9999}) {
  const [expanded, setExpanded] = useState(false);
  const dispatch = useDispatch();
  const faqList = useSelector((state) => state.promo.faq.response?.faqlist) || [];
  const faqListLoading = useSelector((state) => state.promo.faq.loading);
  const [faqListLimited, setFaqListLimited] = useState([]);

  useEffect(() => {
    if (!faqList) return;
  
    const newList = limit < faqList.length
      ? faqList.slice(0, limit)
      : faqList;
  
    // Só atualiza se mudar mesmo
    setFaqListLimited((prev) => {
      const isEqual = JSON.stringify(prev) === JSON.stringify(newList);
      return isEqual ? prev : newList;
    });
  }, [faqList, limit]);

  useEffect(() => {
    dispatch(PromoActions.getFaq());
  }, [dispatch]);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const addEmailLinks = (htmlContent) => {
    const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi;
    return htmlContent.replace(emailRegex, '<a style="color:black; text-decoration: underline;" href="mailto:$1">$1</a>');
  };

  const FaqContent = () => {

    return (
      <S.FAQContainer>
        {faqListLimited.map((item, i) => {
          const index = String(i + 1).padStart(2, '0');
          const processedBody = addEmailLinks(item.body.replace(/\n/g, "<br/>"));

          return (
            <S.AccordionHolder key={index}>
              <Accordion
                square
                expanded={expanded === `panel${i}`}
                onChange={handleChange(`panel${i}`)}
              >
                <AccordionSummary
                  expandIcon={
                    <S.ExpandIcon expanded={expanded === `panel${i}`}>
                      {expanded === `panel${i}` ? "-" : "+"}
                    </S.ExpandIcon>
                  }
                  aria-controls={`pannel${i}-content`}
                  id={`pannel${i}-header`}
                >
                  <S.AccordionQuestion expanded={expanded === `panel${i}`}>
                    <S.SequenceNumber>{index}.</S.SequenceNumber>
                    <strong>{item.title}</strong>
                  </S.AccordionQuestion>
                </AccordionSummary>
                <AccordionDetails>
                  <S.AccordionAnswer>{ReactHtmlParser(processedBody)}</S.AccordionAnswer>
                </AccordionDetails>
              </Accordion>
            </S.AccordionHolder>
          );
        })}
      </S.FAQContainer>
    );
  };

  return faqListLoading ? (
    <Margin>
      <Loading />
    </Margin>
  ) : (
    <FaqContent />
  );
}
